import {createStructuredSelector} from "reselect"
import {connect} from "react-redux"
import React, {Component} from "react"
import styled from "styled-components"

import {
  selectClosePropertyAddress,
  selectIsSettlementSelectionNew,
  selectIsSettlementSelectionPrior,
} from "manager/selectors/referral_status_selectors"
import {AddButton} from "manager/views/components/ReferralStatus/Common/ReferralSatusButtons"
import TitleProviderAutocomplete from "manager/views/components/ReferralStatus/Common/TitleProviderAutocomplete";

const ContractTitleFormContainer = styled.div`
  padding: 0px 0px 18px;
  border-radius: 6px;
  margin: 8px 15px;
`

class StatusClosedTitleForm extends Component {
  state = {
    addProviderClicked: false
  }

  addProvider = () => {
    this.setState({addProviderClicked: true})
  }

  render() {

    const { isSettlementSelectionPrior, isSettlementSelectionNew, closePropertyAddress } = this.props
    let component
    if(!this.state.addProviderClicked && !isSettlementSelectionPrior && !isSettlementSelectionNew) {
      component = (<AddButton onClick={this.addProvider}>Add Provider</AddButton>)
    } else {
      component = (<TitleProviderAutocomplete getOriginAddrOverride={() => closePropertyAddress}/>)
    }

    return (
      <ContractTitleFormContainer>
        {component}
      </ContractTitleFormContainer>

    )
  }
}


const selector = createStructuredSelector({
  isSettlementSelectionPrior: selectIsSettlementSelectionPrior,
  isSettlementSelectionNew: selectIsSettlementSelectionNew,
  closePropertyAddress: selectClosePropertyAddress,
})

export default connect(selector)(StatusClosedTitleForm)
